import React, {useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Input } from "../../../_metronic/_partials/controls";
import JoditEditor from "jodit-react";


const Schema = Yup.object().shape({
  plan_name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Plan Name is required"),
    plan_desc: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Plan Description is required"),
    plan_price: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Plan Price is required"),
    plan_inventory: Yup.string()
    .when("inventory_type",{
      is:"custom",
      then: Yup.string().required("Plan Inventory is required")
      .matches(/^[1-9]+$/, "Plan Inventory should not contain digits like 0 and -1")
    })
  
});

export function CartPriceEditAddForm({ cart, id, btnRef, saveCart }) {
  const editor = React.useRef(null);
const config = {
  readonly: false, // all options from https://xdsoft.net/jodit/doc/
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
};
const [content, setContent] = React.useState("");
  
const options = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

  const [checkFlag, setCheckFlag] = useState({
    status: true
  });
  const handleStatus = (e,setFieldValue) => {
    let elementValue = e.target.value;
    let elementName = e.target.name;
    setCheckFlag(!checkFlag.status);
    setFieldValue(elementName, elementValue)
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={cart}
        validationSchema={Schema}        
        onSubmit={async (values, { setErrors }) => {
          await saveCart(values);
        }}
      >
        {({ handleSubmit, field, setFieldValue, values, handleChange, errors }) => (
         <>
            <Form className='form form-label-right'>
             
             <div className='form-group row mt-5'>
               <Field
                 name="plan_name"
                 component = {Input}
                 placeholder = 'Plan Name'
                 label = "Plan Name"
               />
             </div>
             <div className='form-group row mt-5'>
               <Field
                 name="plan_price"
                 component = {Input}
                 placeholder = 'Plan Price'
                 label = "Plan Price"
               />
             </div>

             <div className='form-group row mt-5'>
               <label className="col-xl-2 col-lg-2"></label>
               <label className="col-xl-2 col-lg-2 col-form-label">Plan Type</label>
               <div className="col-lg-6 col-xl-6">
                 <Select
                   classNamePrefix='selected plans'
                   options={options} 
                   name='plan_type'
                   onChange={async (selectedOption) => {
                     setFieldValue(
                       "plan_type",
                       selectedOption.value
                     );
                   }}
                   value={options?.filter(function(option) {
                     return option.value === values.plan_type;                      
                   })}
                 />
               </div>
             </div>

            

             {id ? (
                <React.Fragment>
                  <div className='form-group row mt-5'>
                    <label className="col-xl-2 col-lg-2"></label>
                    <label className="col-xl-2 col-lg-2 col-form-label">Invenoty Type</label>
                    <div className="col-lg-6 col-xl-6">
                      <div className='radio-inline mt-3'>
                        <label className='radio'>
                          <Field
                            type='radio'
                            name='inventory_type'
                            value="unlimited"
                            onChange={(e) => {
                              console.log(e.target.value)
                              handleStatus(e, setFieldValue)
                            }}

                          />
                          <span></span>
                          Unlimited
                        </label>
                        <label className='radio'>
                          <Field
                            type='radio'
                            value="custom"
                            name='inventory_type'
                            onChange={(e) => {
                              handleStatus(e, setFieldValue)
                            }}

                          />
                          <span></span>
                          Custom
                        </label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>) : (
                <React.Fragment>
                  <div className='form-group row mt-5'>
                    <label className="col-xl-2 col-lg-2"></label>
                    <label className="col-xl-2 col-lg-2 col-form-label">Invenoty Type</label>
                    <div className="col-lg-6 col-xl-6">
                      <div className='radio-inline mt-3'>
                        <label className='radio'>
                          <Field
                            type='radio'
                            name='inventory_type'
                            value="unlimited"
                            onChange={(e) => {
                              handleStatus(e, setFieldValue)
                            }}
                            checked={values.inventory_type === "unlimited" || values.inventory_type === ""}
                          // readOnly
                          />
                          <span></span>
                          Unlimited
                        </label>
                        <label className='radio'>
                          <Field
                            type='radio'
                            value="custom"
                            name='inventory_type'
                            onChange={(e) => {
                              handleStatus(e, setFieldValue)
                            }}
                            checked={values.inventory_type === "custom"}
                          // readOnly

                          />
                          <span></span>
                          Custom
                        </label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>)}
             {values.inventory_type === "custom" ?
             <div className='form-group row mt-5'>
               <Field
                 name="plan_inventory"
                 component = {Input}
                 type="number"
                 placeholder = 'Plan Product Inventoty'
                 label = "Plan Product Inventoty"
               />
             </div>:""}
             <div className='form-group row mt-5'>
                <label className="col-xl-2 col-lg-2"></label>
                <label className="col-xl-2 col-lg-2 col-form-label">Enter price description</label>
                <div className="col-lg-6 col-xl-6">
                  {id ? (
                    <React.Fragment>
                      <JoditEditor
                        ref={editor}
                        value={cart.plan_desc}
                        config={config}
                        tabIndex={5} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => {
                          setFieldValue("plan_desc", newContent);
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <JoditEditor
                        ref={editor}
                        value={content}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => {
                          setFieldValue("plan_desc", newContent);
                        }}
                      />
                    </React.Fragment>
                  )}

                </div>
              </div>
             <button
               type='submit'
               style={{ display: "none" }}
               ref={btnRef}
               onSubmit={() => handleSubmit()}>
             </button>
         
           </Form>
         </>
        )}
      </Formik>
    </>
  );
}
